import dayjs from 'dayjs';

/**
 * [magánóra-sorozat, 2026-10-31, 2. web-validátor FONTOS lelet] A MUI dátummező `onChange`-e GÉPELÉS KÖZBEN is hív —
 * a köztes értékekkel. MI VOLT A BAJ (`EventCreateDialog.tsx` „Dátum", régen `:1093-1096`): az `onChange` minden
 * hívást `date.format('YYYY-MM-DD')`-del az állapotba írt, ellenőrzés nélkül. Egyben begépelt `20270210`-nél a köztes
 * év „0002" lett → `'0002-…'` → a visszaadott `dayjs('0002-…')` 1902-re fordult (JS `Date` két-jegyű év), az érvénytelen
 * köztes nap pedig `'Invalid Date'`-et írt — a mező újrarajzolódott és KIÜRÜLT (mérve, E2E és validátor).
 *
 * A SZABÁLY: csak ÉRVÉNYES (`isValid()`) és értelmes évtartományú dátum kerül az állapotba; köztes / érvénytelen
 * értéknél `null` → a hívó NEM ír, az állapot (és így a mező értéke) változatlan, a MUI a begépelt szekciókat megtartja.
 */
export const PICKER_MIN_YEAR = 2000;
export const PICKER_MAX_YEAR = 2100;

export function pickerValueToIsoDate(value: unknown): string | null {
  if (!value || !dayjs.isDayjs(value) || !value.isValid()) return null;
  const year = value.year();
  if (year < PICKER_MIN_YEAR || year > PICKER_MAX_YEAR) return null;
  return value.format('YYYY-MM-DD');
}
